module.exports = __webpack_public_path__ + "img/016-017.f434c368.jpg";